<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <template v-else>
      <h4 v-if="projectId" class="pa-1 pl-2">{{$t('message.projects.project')}}: {{showProjectName}}</h4>
      <v-row class="mt-3 mb-2 mx-0" v-if="false">
        <v-col cols="12" class="pa-0 pl-1 pt-1">
          <v-autocomplete outlined dense :label="$t('message.equipments.equipment')" :items="listOfEquipments" hide-details v-model="activeEquipmentId" @change="getSingleRecord(activeEquipmentId)" item-text="equipmentName" item-value="id"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="my-2 mx-0">
        <form-data :references.sync="formReferences" :model="modelObj" ref="equipmentFormRef">
          <template v-if="modelObj.id && listOfDocuments.length > 0" slot="equipment_documents">
            <documents :documents="listOfDocuments" :deleteIds="deleteDocumentIds"></documents>
          </template>
        </form-data>
      </v-row>
      <v-row class="mb-2 mx-0" v-if="modelObj.is_checklist_motor === 1 && !this.isReadonly">
        <v-speed-dial v-model="showItems" bottom fixed class="custom-speed-dial">
          <template v-slot:activator>
            <v-btn v-model="showItems" color="primary" dark fab>
              <v-icon v-if="showItems">mdi-close</v-icon>
              <v-icon v-else>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-btn class="text-capitalize" min-width="80px" color="primary" v-for="item in speedDialItems" :key="`${item.name}_menuitem`" :to="item.to">{{ item.name }}</v-btn>
        </v-speed-dial>
      </v-row>
    </template>
  </div>
</template>

<script>
import FormTemplate from '@/components/FormTemplate'
import { mapGetters } from 'vuex'
import { hostAppApi } from '../../plugins/axios_settings'
import PermissionsMixin from '@/mixins/permissions'
import projectMixin from '@/mixins/projectMixin'

export default {
  mixins: [PermissionsMixin, projectMixin],
  data () {
    return {
      modelObj: {
        id: parseInt(this.$route.params.id),
        project_id: this.$route.query.project_id ? parseInt(this.$route.query.project_id) : 0,
        status: 1,
        responsible_id: null
      },
      listOfEquipments: [],
      listOfDocuments: [],
      deleteDocumentIds: [],
      activeEquipmentId: 0,
      showItems: false,
      hostUserId: this.$cookie.get(process.env.VUE_APP_HOST_USER) ? this.$cookie.get(process.env.VUE_APP_HOST_USER) : 0,
      fieldsLoading: false,
      /* equipment crud */
      listOfProjects: [],
      listOfResponsibleUsers: [],
      listOfEquipmentLocations: [],
      loading: false,
      isReadonly: false,
      projectId: this.$route.query.project_id ? parseInt(this.$route.query.project_id) : 0,
      backUrl: '',
      MODULE: '',
      hideDetails: true
    }
  },
  computed: {
    ...mapGetters(['formType', 'getHostRefApi']),
    formReferences () {
      return {
        title: this.isReadonly ? this.$t('message.equipments.viewEquipment') : this.modelObj.id ? this.$t('message.equipments.equipment') : this.$t('message.equipments.addEquipment'),
        properties: [{
          model: 'project_id',
          type: this.formType.AUTO_COMPLETE,
          rules: this.modelObj.location_id ? [] : this.$_requiredValidation,
          items: this.listOfProjects,
          select_text: (item) => this.setProjectname(item),
          select_value: 'id',
          change: this.handleProjectChange,
          label: this.$t('message.projects.project'),
          class: 'xs12 sm6 md4 lg3 helptext-style',
          disabled: this.isReadonly,
          is_show: !this.$store.state.common.isProjectExcluded ? !this.projectId : false
        }, {
          model: 'location_id',
          type: this.formType.AUTO_COMPLETE,
          rules: this.modelObj.project_id ? [] : this.$_requiredValidation,
          items: this.listOfEquipmentLocations,
          select_text: 'name',
          change: this.handleLocationChange,
          select_value: 'id',
          label: this.$t('message.deviation.location'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'equipment_number',
          type: this.formType.TEXT,
          rules: [...this.$_requiredValidation, ...this.$_sharepointCharacters],
          max: 50,
          label: this.$t('message.equipments.equipmentNumber'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'name',
          type: this.formType.TEXT,
          rules: [...this.$_requiredValidation, ...this.$_sharepointCharacters],
          max: 35,
          label: this.$t('message.common.name'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'located',
          type: this.formType.TEXT,
          rules: [],
          max: 35,
          label: this.$t('message.equipments.placement'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'description',
          type: this.formType.TEXT,
          rules: this.charLengthValidation(35),
          label: this.$t('message.deviation.description'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly,
          hideDetails: this.hideDetails
        },
        {
          model: 'product',
          type: this.formType.TEXT,
          rules: [],
          max: 35,
          label: this.$t('message.equipments.product'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'model_number',
          type: this.formType.TEXT,
          rules: [],
          max: 15,
          label: this.$t('message.equipments.modelNumber'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'serial_number',
          type: this.formType.TEXT,
          rules: [],
          max: 50,
          label: this.$t('message.equipments.serialNumber'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'capacity',
          type: this.formType.TEXT,
          rules: [],
          max: 50,
          label: this.$t('message.equipments.capacity'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        }, {
          model: 'groups',
          type: this.formType.TEXT,
          rules: [],
          max: 50,
          label: this.$t('message.equipments.groups'),
          class: 'xs12 sm6 md4 lg3',
          disabled: this.isReadonly
        },
        {
          model: 'files',
          type: this.formType.FILES,
          multiple: true,
          rules: this.$_maxFileSizeValidation(100, this.modelObj.files), // this.$_multiSelectValidation // size in MB
          accept: '.xlsx, .xls, image/*, .doc, .docx, .txt, .pdf',
          label: this.$t('message.deviation.upload_files'),
          class: 'xs12 sm4 md3',
          disabled: this.isReadonly,
          slot: 'equipment_documents',
          hideDetails: this.hideDetails
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true,
          disabled: this.isReadonly
        }, {
          name: 'back',
          color: 'info',
          click: () => this.$router.go(-1), // this.$router.push(this.backUrl),
          label: this.$t('message.login.back'),
          to: this.backUrl,
          is_show: true
        }]
      }
    },
    speedDialItems () {
      const speedDialItems = []
      const equipmentCheckList = {
        name: this.$t('message.checklist.title'),
        icon: 'mdi-book-plus',
        to: this.projectId ? `/equipments/${this.activeEquipmentId}/checklists?projectequipment=1` : `/equipments/${this.activeEquipmentId}/checklists`
      }
      speedDialItems.push(equipmentCheckList) // if (this.$store.state.common.includeEquipmentChecklist) speedDialItems.push(equipmentCheckList)
      return speedDialItems
    },
    listOfEquipmentStatus () {
      return [
        { text: this.$t('message.equipments.active'), value: 1 },
        { text: this.$t('message.equipments.quarantine'), value: 2 },
        { text: this.$t('message.equipments.discarded'), value: 3 }
      ]
    },
    showProjectName () {
      const project = this.listOfProjects.find(x => x.id === this.projectId)
      let name = ''
      if (project) name = this.setProjectname(project)
      return name
    }
  },
  created () {
    // this.getAllEquipments()
    this.MODULE = 'equipment'
    if (this.$route.query.project_id) this.MODULE = 'projectequipment'
    if (this.$route.name === 'eqipment_edit') this.isReadonly = !this.checkActionPermission(this.MODULE, this.CONSTANTS.EDIT)
    if (this.$route.name === 'eqipment_add') this.isReadonly = !this.checkActionPermission(this.MODULE, this.CONSTANTS.CREATE)
    this.getAllProjects()
    this.getAllUsers()
    this.getEquipmentLocations()
  },
  mounted () {
    if (this.$route.params.id) {
      // this.getAllEquipments()
      this.getSingleRecord(this.$route.params.id)
      this.activeEquipmentId = parseInt(this.$route.params.id)
    }
    // set back url
    this.backUrl = this.projectId ? `/projects/${this.projectId}/equipments` : '/equipments'
  },
  methods: {
    getSingleRecord (id) {
      this.fieldsLoading = true
      hostAppApi.get(`${this.getHostRefApi}equipment/${id}/edit?user_id=${this.hostUserId}`)
        .then((response) => {
          const transformData = { date: { list: ['warranty_date', 'scrapping'], from: 'YYYY-MM-DD', to: 'DD.MM.YYYY' } }
          const model = this.$formatter.formatModel(response.data, transformData)
          this.listOfDocuments = this.$formatter.removeInvalidFromArrayObject(model.documents)
          if (response.data) this.modelObj = this.$formatter.cloneVariable(model)
        })
        .catch((e) => {
          this.$router.push('/dashboard')
        })
        .finally(() => {
          this.fieldsLoading = false
          const apiProjectId = this.modelObj && this.modelObj.project_id ? this.modelObj.project_id : 0
          this.getEquipmentLocations(apiProjectId)
        })
    },
    getAllEquipments () {
      this.getSetListItems(`${this.getHostRefApi}equipment?only_items=1`, 'listOfEquipments') // 4 is all, 2 is myall
    },
    getSetListItems (url, listName) {
      hostAppApi.get(url).then((response) => {
        if (response.data) {
          if (listName === 'listOfEquipments') {
            const list = this.$formatter.cloneVariable(response.data.data)
            list.forEach(element => {
              // eslint-disable-next-line camelcase
              element.equipmentName = element.equipment_number ? `${element.equipment_number} - ` : ''
              element.equipmentName += element.name || ''
            })
            this[listName] = list
          }
        }
      })
    },
    /* equipment crud */
    getAllProjects () {
      this.$api.execute('get', `projects/get_as_simplified_for_pwa?filter=${this.isAdmin() ? 3 : 2}`).then((response) => {
        this.listOfProjects = response.data
      })
    },
    getAllUsers () {
      this.$api.execute('get', 'users').then(response => {
        this.listOfResponsibleUsers = response.data
      })
    },
    saveUpdateHandler () {
      if (this.$refs.equipmentFormRef.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.modelObj
        const userid = this.$cookie.get(process.env.VUE_APP_HOST_USER) ? this.$cookie.get(process.env.VUE_APP_HOST_USER) : 0
        if (userid) model.user_id = parseInt(userid)
        const text = model.id ? 'message.common.updatedSuccess' : 'message.common.addedSucess'
        model = this.$formatter.removeInvalidFromObject(model)
        const formData = new FormData()
        const files = this.modelObj.files
        const responsibleId = this.modelObj.responsible_id

        if (files) {
          const Newfile = [...files]
          Newfile.forEach((file, i) => {
            formData.append('document[' + i + ']', file)
          })
        }
        if (responsibleId) {
          responsibleId.forEach((id, i) => {
            formData.append('responsible_id[' + i + ']', id)
          })
        }
        const newobj = this.$formatter.removeInvalidFromObject(model)
        for (const key in newobj) {
          if (key !== 'files' || key !== 'responsible_id') formData.append(key, key === 'is_completed' ? newobj[key] : newobj[key] || newobj[key])
        }
        const header = {
          'Content-Type': 'multipart/form-data',
          language: this.$i18n.locale
        }
        let url = this.getHostRefApi
        url += model.id ? `equipment/${model.id}/update` : 'equipment'
        const ids = [...this.deleteDocumentIds]
        if (model.id && ids.length > 0) formData.append('document_delete_ids', ids)
        hostAppApi.post(url, formData, { headers: header })
          .then(response => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
            this.$router.push(this.backUrl)
          })
          // .catch((error) => {
          //   if (error.response && error.response.data && error.response.data.message) {
          //     const errorList = error.response.data.message
          //     this.$root.$emit('snackbar', { snackbar: true, color: 'error', isException: true, text: errorList })
          //   } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: error })
          // })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
    },
    getEquipmentLocations () {
      hostAppApi.get(`${this.getHostRefApi}get_active_equipment_locations`)
        .then((response) => {
          this.listOfEquipmentLocations = response.data.results
        })
    },
    charLengthValidation (length) {
      return [
        (v) => {
          const data = v ? (v && v.length <= length) || this.$t('message.common.charsLimit35', { length: length }) : true
          if (typeof data !== 'boolean') this.hideDetails = false
          else this.hideDetails = true
          return data
        }
      ]
    }
  },
  components: {
    'form-data': FormTemplate,
    documents: () => import('@/components/Documents/Documents')
  }
}
</script>

<style>
.custom-speed-dial div.v-speed-dial__list {
  align-items: baseline !important;
}
@media only screen and (min-width: 768px) {
  .v-speed-dial--bottom {
    bottom: 14vh !important;
  }
}
@media only screen and (max-width: 767px) {
  .v-speed-dial--bottom {
    bottom: 10vh !important;
  }
}
.helptext-style > span {
  font-size: 80%;
  padding-left: 2%;
  color: red;
}
</style>
